export default "__VITE_ASSET__Ds4b8$IS__"